import React from "react";
import { Stack, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, Dialog, DialogTitle, DialogContent, Button, Divider } from "@mui/material";
import { setModel, selectModel, setUseTools, selectUseTools, selectUseSuggestions, setUseSuggestions, setUseAdminTools, selectUseAdminTools } from '../../state/chatSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AI_MODELS } from './constants';

function DevToolsDialog({
    open,
    onClose,
    fullScreen
}) {

    const dispatch = useDispatch();
    const model = useSelector(selectModel);
    const useTools = useSelector(selectUseTools);
    const useSuggestions = useSelector(selectUseSuggestions);
    const useAdminTools = useSelector(selectUseAdminTools);

    return (
        <Dialog
            direction="row"
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
        >
            <DialogTitle>Developer Console</DialogTitle>
            <DialogContent>
                <Stack
                    minWidth={fullScreen ? '100%' : '400px'}
                    direction="column"
                    maxHeight={fullScreen ? 'unset' : '80vh'}
                    spacing={2}
                    sx={{
                        mt: 2,
                    }}
                >
                    <FormControl variant="outlined" sx={{
                        width: '100%',
                    }}>
                        <InputLabel id="model-selector-label">Model</InputLabel>
                        <Select
                            size="small"
                            labelId="model-selector-label"
                            id="model-selector"
                            value={model}
                            onChange={(e) => dispatch(setModel(e.target.value))}
                            label="Model"
                        >
                            {AI_MODELS.map((m) => (
                                <MenuItem key={m.value} value={m.value}>
                                    {m.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        checked={useTools}
                        onChange={(e) => dispatch(setUseTools(e.target.checked))}
                        control={<Switch
                            size="small"
                            color="primary" />}
                        label="Use Tools"
                        labelPlacement="end"
                    />
                    <FormControlLabel
                        checked={useSuggestions}
                        onChange={(e) => dispatch(setUseSuggestions(e.target.checked))}
                        control={<Switch
                            size="small"
                            color="primary" />}
                        label="Use Suggestions"
                        labelPlacement="end"
                    />
                    <FormControlLabel
                        checked={useAdminTools}
                        onChange={(e) => dispatch(setUseAdminTools(e.target.checked))}
                        control={<Switch
                            size="small"
                            color="primary" />}
                        label="Use Admin Tools"
                        labelPlacement="end"
                    />
                    <Divider
                        sx={{
                            my: 2,
                        }}
                    ></Divider>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClose}
                    >Close</Button>
                </Stack>
            </DialogContent>
        </Dialog >
    );
}

export default DevToolsDialog;
